module.exports = __webpack_public_path__ + "static/media/BoardMarking.6eb430b7.jpg";